import {useEffect, useState} from "react";
import {getProductPriceBySlug, quoteCart} from "../api/shop";

export const useProductPrice = (product, variantId, itemIds, quantity = 1) => {
  const items = [...new Set(itemIds)].sort().join(",");
  const identifier = product.urlSlug || product.productId;
  const key = `${identifier}:${variantId || ""}:${items}:${quantity}`;
  const baseAvailable = quantity === 1 && !variantId && !items && typeof product.priceWithTax === "number" && Number.isFinite(product.priceWithTax);
  const [attempt, setAttempt] = useState(0);
  const [quote, setQuote] = useState({key:null, price:null, lineTotal:null, busy:true, error:false});

  useEffect(() => {
    if (baseAvailable) return;
    let active = true;
    setQuote({key, price:null, lineTotal:null, busy:true, error:false});
    (async () => {
      try {
        let price, lineTotal;
        if (quantity === 1) {
          const response = await getProductPriceBySlug(identifier, {variantId:variantId || "", itemIds:items});
          price = response?.data?.priceWithTax; lineTotal = price;
          if (response?.error !== false) throw new Error("Price unavailable");
        } else {
          const response = await quoteCart({lines:[{productId:product.productId, quantity, variantId:variantId || "", itemIds:items ? items.split(",") : []}]});
          const line = response?.data?.lines?.[0];
          price = line?.unitPriceWithTax; lineTotal = line?.lineTotalWithTax;
          if (response?.error !== false || line?.quantity !== quantity || line?.productId !== product.productId) throw new Error("Price unavailable");
        }
        if (![price,lineTotal].every(value => typeof value === "number" && Number.isFinite(value))) throw new Error("Price unavailable");
        if (active) setQuote({key, price, lineTotal, busy:false, error:false});
      } catch {
        if (active) setQuote({key, price:null, lineTotal:null, busy:false, error:true});
      }
    })();
    return () => { active = false; };
  }, [identifier, variantId, items, key, attempt, baseAvailable, quantity, product.productId]);

  if (baseAvailable) return {price:product.priceWithTax, lineTotal:product.priceWithTax, busy:false, error:false};
  const current = quote.key === key ? quote : {price:null, lineTotal:null, busy:true, error:false};
  return {...current, retry:() => {
    if (current.busy) return;
    setQuote({key,price:null,lineTotal:null,busy:true,error:false});
    setAttempt(value=>value+1);
  }};
};
